import {IEntityDocumentSummary} from './entity-document-summary';
import {IDateTimeWithZone} from '../common/date-time-with-zone.interface';
import {IOperative} from './operative.interface';
import {DateTimeWithZone} from '../common/date-time-with-zone.class';
import {IObservation} from './observation.interface';
import {TrainingRecordObservation} from '../domain-model/training-record-observation.class';
import { DocumentEntityType } from './document-entity-type.enum';

export class EntityDocumentSummary implements IEntityDocumentSummary {
  constructor(entityDocumentSummary?: IEntityDocumentSummary) {
    this.documentCreationDate = new DateTimeWithZone(entityDocumentSummary?.documentCreationDate) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.documentId = entityDocumentSummary?.documentId || '00000000-0000-0000-0000-000000000000';
    this.documentTypeId = entityDocumentSummary?.documentTypeId || '';
    this.documentType = entityDocumentSummary?.documentType || '';
    this.originalFilename = entityDocumentSummary?.originalFilename || '';
    this.expiryDate = new DateTimeWithZone(entityDocumentSummary?.expiryDate) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.reviewDate = new DateTimeWithZone(entityDocumentSummary?.reviewDate) || new DateTimeWithZone({} as IDateTimeWithZone);
    this.observations = entityDocumentSummary?.observations || new Array<IObservation>();
    this.totalObservations = entityDocumentSummary?.totalObservations || 0;
    this.canPreviewDocument = entityDocumentSummary?.canPreviewDocument;
    this.extraDescription = entityDocumentSummary?.extraDescription || "";
    this.entityType = entityDocumentSummary?.entityType
  }
  documentCreationDate: DateTimeWithZone;
  documentId: string;
  documentType: string;
  documentTypeId: string;
  expiryDate: DateTimeWithZone;
  originalFilename: string;
  reviewDate: DateTimeWithZone;
  observations: IObservation[];
  totalObservations: number;
  canPreviewDocument: boolean;
  extraDescription: string;
  entityType: DocumentEntityType;
}
